export const PRICING = {
  STRING_36_MONTHLY: 'pricing.36-monthly-price',
  STRING_48_MONTHLY: 'pricing.48-monthly-price',
  STRING_36_MONTHLY_AS_SECONDARY_PRICE: 'pricing.36-monthly-price-as-secondary-price',
  STRING_48_MONTHLY_AS_SECONDARY_PRICE: 'pricing.48-monthly-price-as-secondary-price',
  STRING_THREE_MONTH: 'pricing.three-month-price',
  STRING_THREE_MONTH_AS_SECONDARY_PRICE: 'pricing.three-month-price-as-secondary-price',
  STRING_UPFRONT: 'pricing.upfront',
  STRING_UPFRONT_AS_SECONDARY_PRICE: 'pricing.upfront-as-secondary-price',
  STRING_MONTHLY_PRICE: 'pricing.monthly-price',
  STRING_MONTHLY_AS_SECONDARY_PRICE: 'pricing.monthly-price-as-secondary-price',
  STRING_MSRP: 'pricing.msrp',
};
